import axios, { AxiosError } from 'axios'
import { t } from 'i18next'
import { toast } from 'react-toastify'

interface ErrorResponse {
  message: string
}

export const handleError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const apiError = error as AxiosError<ErrorResponse>

    if (apiError.response && apiError.response.data) {
      const message = apiError.response.data.message
      toast.error(message || t('somethingWentWrong'))
    } else {
      toast.error(apiError.message || t('unexpectedError'))
    }
  } else {
    toast.error(t('unexpectedError'))
  }
}
